import React, { useState, useContext } from "react";
import { Paper, Grid } from "@material-ui/core";

import {
  InputTextMaster,
  InputTextArea,
  InputCheckboxMaster,
  InputOptionMaster,
  MasterButton,
  InputReactDatepicker,
  ModalDeleteConfirm,
} from "App/Component/ui";

import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  WMS_FA_INPUT,
  instance4,
  STYLE_DEFAULT_MASTER,
  TYPE_INSTANCE4,
  // TYPE_INSTANCE2,
  // DEFAULT_VALUE_OPTION,
  DISABLED_BUTTON_SUBMIT,
  TYPE_INSTANCE5,
} from "App/constants";

import { useSelectOption } from "App/hooks";

import {
  batalPembelianFA,
  RESET_STATE_INPUT_FIXED_ASSET,
  urlAddFixedAsset,
  urlGetFiscal,
  urlGetGudangUtama,
  urlGetMetodePenyusutan,
  urlGetProdusen,
  // urlGetRole,
  urlGetSupplier,
  // urlGetTingkatAsset,
  urlGetTipe,
  urlSetType,
  urlUpdateFixedAsset,
  validation,
} from "./helpers";

import {
  convertToValidPrice,
  dateTimePickerToValidDate,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
  removeLocalStorageAsFormData,
} from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { RESET_STATE_DATA_FIXED_ASSET } from "../../helpers";
import { handleClickCetakLabelAsset } from "App/Component/layout/Registrasi/utils";
import { useMultipleSelect } from "hooks";
import { validasiMultipleSelect } from "hooks/useMultipleSelect";
import { useSelector } from "react-redux";
import { LIST_URL_AKUNTANSI } from "utils/akuntansi";

export default function TabFixedAsset() {
  const {
    formData,
    setFormData,
    headData,
    setHeadData,
    setDisabledInput,
    setDataHistory,
    setDataPenyusutan,
  } = useContext(FormContext);
  const { setting } = useSelector((state) => state);
  const printerEnv = setting.printer_env;
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const coa = useMultipleSelect([
    {
      url: LIST_URL_AKUNTANSI.coa.getByLevel,
      search: true,
      type_instance: TYPE_INSTANCE5,
      value: "id",
      label: ["name", "code"],
      options: { headers: { level: 4 } },
      type_response: "body",
      key: "name",
      attr_addition: ["name", "code"],
      attr_addition_value: ["name", "code"],
    },
  ]);

  const classes = STYLE_DEFAULT_MASTER();

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleChangeDate = (e, text) => {
    setFormData({
      ...formData,
      [text]: dateTimePickerToValidDate(e),
    });
  };

  const handleReset = () => {
    setFormData(RESET_STATE_INPUT_FIXED_ASSET);
    setHeadData(RESET_STATE_DATA_FIXED_ASSET);
    setDisabledInput(false);
    setDataHistory([]);
    setDataPenyusutan([]);
  };

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    if (isNull(e)) {
      setFormData({
        ...formData,
        [name_id]: null,
        [name_label]: "Pilih",
      });
    } else {
      setFormData({
        ...formData,
        [name_id]: e?.value,
        [name_label]: e?.label,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const valid = await validation(formData);
      let api;
      if (valid) {
        if (formData.id === "") {
          api = await instance4.post(urlAddFixedAsset, {
            ...formData,
            harga_perolehan: convertToValidPrice(formData.harga_perolehan2),
            nilai_sisaditaksir: convertToValidPrice(
              formData.nilai_sisaditaksir2
            ),
            nilai_aset: convertToValidPrice(formData.nilai_aset2),
          });
          const res = api?.data;
          if (res.status) {
            setFormData({
              ...formData,
              id: res.body.id,
              code: res.body.code,
            });
            setHeadData({
              ...headData,
              id: res.body.id,
              idgl: res.body.idgl,
              total_penyusutan: res.body.total_penyusutan,
              total_cicilan: res.body.total_cicilan,
              sisa_pemby: res.body.sisa_pemby,
            });
            defaultToastSuccess(res?.message);
          } else {
            defaultToastError(res?.message);
          }
        } else {
          api = await instance4.post(
            urlUpdateFixedAsset,
            {
              ...formData,
              harga_perolehan: convertToValidPrice(formData.harga_perolehan2),
              nilai_sisaditaksir: convertToValidPrice(
                formData.nilai_sisaditaksir2
              ),
              nilai_aset: convertToValidPrice(formData.nilai_aset2),
            },
            {
              headers: {
                idfixasset: formData.id,
              },
            }
          );
          const res = api?.data;
          if (res.status) {
            defaultToastSuccess(res?.message);
            removeLocalStorageAsFormData(WMS_FA_INPUT);
            setFormData(RESET_STATE_INPUT_FIXED_ASSET);
            setHeadData(RESET_STATE_DATA_FIXED_ASSET);
          } else {
            defaultToastError(res?.message);
          }
        }
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  function clickBatalPembelian(row) {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  async function batalPembelian() {
    const res = await batalPembelianFA(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      handleReset();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <Paper
      className={classes.paper}
      style={{
        padding: "0.8rem 1rem",
      }}
    >
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => batalPembelian()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          msg="Anda yakin ingin membatalkan pembelian dari fixed asset ini?"
          title="Batal Pembelian Fixed Asset"
          labelConfirm="Ya, Batalkan Pembelian"
        />
      )}
      <form onSubmit={(e) => (disabled.disabled ? null : handleSubmit(e))}>
        <Grid container spacing={3}>
          <Grid item sm={6}>
            <FormLeft
              handleChange={handleChange}
              handleChangeDate={handleChangeDate}
              formData={formData}
              setFormData={setFormData}
              headData={headData}
            />
          </Grid>
          <Grid item sm={6}>
            <FormRight
              handleChange={handleChange}
              formData={formData}
              setFormData={setFormData}
              handleChangeSelect={changeSelectWithLocalStorage}
              coa={coa}
              headData={headData}
            />
          </Grid>
        </Grid>

        <div className="mt-2">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <MasterButton
                className={"mt-1"}
                onClick={handleReset}
                type="button"
                color="danger"
                outline={true}
                name="Reset"
                size="md"
              />
              {formData.status_kelengkapan === 0 ||
              formData.status_kelengkapan === null ? (
                <MasterButton
                  className={"mt-1"}
                  onClick={() => clickBatalPembelian()}
                  type="button"
                  color="danger"
                  outline={false}
                  name="Batal Pembelian"
                  size="md"
                />
              ) : (
                <></>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: "20px",
              }}
            >
              <MasterButton
                className={"mt-1"}
                type="button"
                outline={true}
                color={isNull(headData.id) ? "secondary" : "green"}
                name={"CETAK LABEL"}
                size="md"
                onClick={() =>
                  isNull(headData.id)
                    ? null
                    : handleClickCetakLabelAsset(
                        formData,
                        "print-fixed-asset-label",
                        printerEnv.nama_rumah_sakit
                      )
                }
              />

              <MasterButton
                className={"mt-1"}
                type="submit"
                color={disabled.color}
                name={disabled.label}
                disabled={disabled.disabled}
                size="md"
              />
            </div>
          </Grid>
        </div>
      </form>
    </Paper>
  );
}

const FormLeft = ({
  handleChange,
  formData,
  setFormData,
  handleChangeDate,
  headData,
}) => {
  // const role = useSelectOption(
  //   false,
  //   urlGetRole,
  //   TYPE_INSTANCE2,
  //   "id",
  //   "nama_role"
  // );

  return (
    <Grid container spacing={2}>
      {/* <Grid item sm={12}>
        <InputOptionMaster
          name="role_id"
          label="ROLE ID"
          id="role_id"
          withSearch={false}
          data={role?.length > 0 ? role : [DEFAULT_VALUE_OPTION("Pilih Role")]}
          value={formData.role_id}
          onChange={handleChange("role_id")}
        />
      </Grid> */}
      <Grid item sm={12}>
        <InputTextMaster
          name="name"
          label="NAMA"
          id="name"
          value={formData.name}
          onChange={isNull(headData.id) ? handleChange("name") : null}
          disabled={isNull(headData.id) ? false : true}
          placeholder="Nama Fixed Asset"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="code"
          label="KODE"
          id="code"
          value={formData.code}
          // onChange={handleChange("code")}
          disabled={true}
          placeholder="Kode"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="merek"
          label="MEREK"
          id="merek"
          value={isNull(formData.merek) ? "" : formData.merek}
          onChange={handleChange("merek")}
          placeholder="Merek"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="type"
          label="TYPE"
          id="no_sn"
          value={isNull(formData.type) ? "" : formData.type}
          onChange={handleChange("type")}
          placeholder="Type"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="no_sn"
          label="SERIAL NUMBER"
          id="no_sn"
          value={isNull(formData.no_sn) ? "" : formData.no_sn}
          onChange={handleChange("no_sn")}
          placeholder="Serial Number"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="no_akd"
          label="NO AKD"
          id="no_akd"
          value={isNull(formData.no_akd) ? "" : formData.no_akd}
          onChange={handleChange("no_akd")}
          placeholder="No AKD"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="no_akl"
          label="NO AKL"
          id="no_akl"
          value={isNull(formData.no_akl) ? "" : formData.no_akl}
          onChange={handleChange("no_akl")}
          placeholder="No AKL"
        />
      </Grid>
      <Grid item sm={12}>
        <InputTextMaster
          name="nofaktur"
          label="NO FAKTUR"
          id="nofaktur"
          value={isNull(formData.nofaktur) ? "" : formData.nofaktur}
          onChange={handleChange("nofaktur")}
          placeholder="No Faktur"
        />
      </Grid>
      <Grid item sm={12}>
        <InputOptionMaster
          name="status_kelengkapan"
          label="STATUS KELENGKAPAN"
          id="status_kelengkapan"
          value={formData.status_kelengkapan}
          withSearch={false}
          disabled={formData.status_kelengkapan === 1 ? true : false}
          data={[
            {
              value: 0,
              label: "Belum Lengkap",
            },
            {
              value: 1,
              label: "Sudah Lengkap",
            },
          ]}
          onChange={handleChange("status_kelengkapan")}
        />
      </Grid>
      <Grid item sm={12}>
        <InputReactDatepicker
          selected={formData.tgl_pembelian}
          label="Tanggal Pembelian & Waktu"
          dateFormat="dd/MM/yyyy HH:mm"
          timeFormat="HH:mm"
          showTimeSelect={true}
          timeIntervals={5}
          handleChangeToday={(e) =>
            setFormData({
              ...formData,
              tgl_pembelian: e,
            })
          }
          onChange={(e) =>
            setFormData({
              ...formData,
              tgl_pembelian: e,
              tgl_pemakaian: null,
            })
          }
        />
      </Grid>

      <Grid item sm={12}>
        <InputReactDatepicker
          selected={formData.tgl_pemakaian}
          label="Tanggal Pemakaian & Waktu"
          dateFormat="dd/MM/yyyy HH:mm"
          timeFormat="HH:mm"
          minDate={new Date(formData.tgl_pembelian)}
          showTimeSelect={true}
          timeIntervals={5}
          handleChangeToday={(e) =>
            setFormData({
              ...formData,
              tgl_pemakaian: e,
            })
          }
          onChange={(e) =>
            setFormData({
              ...formData,
              tgl_pemakaian: e,
            })
          }
        />
      </Grid>

      {/* <Grid item sm={12}>
        <InputReactDatepicker
          selected={formData.tgl_akhirpenyusutan}
          label="Tanggal Akhir Penyusutan & Waktu"
          dateFormat="dd/MM/yyyy HH:mm"
          timeFormat="HH:mm"
          showTimeSelect={true}
          timeIntervals={5}
          handleChangeToday={(e) =>
            setFormData({
              ...formData,
              tgl_akhirpenyusutan: e,
            })
          }
          onChange={(e) =>
            setFormData({
              ...formData,
              tgl_akhirpenyusutan: e,
            })
          }
        />
      </Grid> */}

      <Grid item sm={12}>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <InputTextMaster
                pattern="[0-9]{1,}"
                name="perkiraan_umur_thn"
                label="PERKIRAAN UMUR"
                id="perkiraan_umur_thn"
                value={isNull(formData.perkiraan_umur_thn) ? "" : formData.perkiraan_umur_thn}
                onChange={(e) => {
                  let valUmurTHN = e.target.value;
                  if (isNull(valUmurTHN)) {
                    setFormData({
                      ...formData,
                      perkiraan_umur_thn: null,
                    });
                  } else {
                    setFormData({
                      ...formData,
                      perkiraan_umur_thn: valUmurTHN,
                    });
                  }
                }}
                placeholder="Umur dalam tahun"
              />
              <div
                style={{
                  marginTop: "1.5rem",
                }}
              >
                THN
              </div>
            </div>
          </Grid>
          <Grid item sm={6}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
                marginTop: "1.5rem",
              }}
            >
              <InputTextMaster
                pattern="[0-9]{1,}"
                name="perkiraan_umur_bln"
                label=""
                id="perkiraan_umur_bln"
                value={isNull(formData.perkiraan_umur_bln) ? "" : formData.perkiraan_umur_bln}
                onChange={(e) => {
                  let valUmurBLN = e.target.value;
                  if (isNull(valUmurBLN)) {
                    setFormData({
                      ...formData,
                      perkiraan_umur_bln: null,
                    });
                  } else {
                    setFormData({
                      ...formData,
                      perkiraan_umur_bln: valUmurBLN,
                    });
                  }
                }}
                placeholder="Umur dalam bulan"
              />
              <div>BLN</div>
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="harga_perolehan2"
          label="HARGA PEROLEHAN"
          id="harga_perolehan2"
          value={formData?.harga_perolehan2}
          disabled={isNull(headData.id) ? false : true}
          onInput={(e) => {
            let val = e.target.value;
            setFormData({
              ...formData,
              harga_perolehan2: formatRupiah(val),
            });
            localStorage.setItem(
              WMS_FA_INPUT,
              JSON.stringify({
                ...formData,
                harga_perolehan2: formatRupiah(val),
              })
            );
          }}
          placeholder="Harga Perolehan"
          withButtonLeft={true}
        >
          <button
            type={"button"}
            onClick={null}
            style={{
              borderLeft: "1px solid #EAEAEA",
              borderTop: "1px solid #EAEAEA",
              borderBottom: "1px solid #EAEAEA",
              borderRight: "0",
              background: "#f7f7f7",
              padding: "0 0 0 0.8rem",
              cursor: "pointer",
              borderRadius: "6px 0 0 6px",
              fontSize: "10px",
            }}
          >
            Rp.
          </button>
        </InputTextMaster>
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="nilai_sisaditaksir2"
          label="NILAI SISA DIKTAKSI/RESIDU"
          id="nilai_sisaditaksir2"
          value={formData.nilai_sisaditaksir2}
          disabled={isNull(headData.id) ? false : true}
          onInput={(e) => {
            let val = e.target.value;
            setFormData({
              ...formData,
              nilai_sisaditaksir2: formatRupiah(val),
            });
            localStorage.setItem(
              WMS_FA_INPUT,
              JSON.stringify({
                ...formData,
                nilai_sisaditaksir2: formatRupiah(val),
              })
            );
          }}
          placeholder="Nilai Sisa Ditaksir/Residu"
          withButtonLeft={true}
        >
          <button
            type={"button"}
            onClick={null}
            style={{
              borderLeft: "1px solid #EAEAEA",
              borderTop: "1px solid #EAEAEA",
              borderBottom: "1px solid #EAEAEA",
              borderRight: "0",
              background: "#f7f7f7",
              padding: "0 0 0 0.8rem",
              cursor: "pointer",
              borderRadius: "6px 0 0 6px",
              fontSize: "10px",
            }}
          >
            Rp.
          </button>
        </InputTextMaster>
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="nilai_aset2"
          label="NILAI ASSET SAAT INI"
          id="nilai_aset2"
          value={formData.nilai_aset2}
          disabled={isNull(headData.id) ? false : true}
          onInput={(e) => {
            let val = e.target.value;
            setFormData({
              ...formData,
              nilai_aset2: formatRupiah(val),
            });
            localStorage.setItem(
              WMS_FA_INPUT,
              JSON.stringify({
                ...formData,
                nilai_aset2: formatRupiah(val),
              })
            );
          }}
          placeholder="Nilai Asset"
          withButtonLeft={true}
        >
          <button
            type={"button"}
            onClick={null}
            style={{
              borderLeft: "1px solid #EAEAEA",
              borderTop: "1px solid #EAEAEA",
              borderBottom: "1px solid #EAEAEA",
              borderRight: "0",
              background: "#f7f7f7",
              padding: "0 0 0 0.8rem",
              cursor: "pointer",
              borderRadius: "6px 0 0 6px",
              fontSize: "10px",
            }}
          >
            Rp.
          </button>
        </InputTextMaster>
      </Grid>
    </Grid>
  );
};

const FormRight = ({ handleChange, formData, setFormData, coa, headData }) => {
  const gudangUtama = useSelectOption(
    false,
    urlGetGudangUtama,
    TYPE_INSTANCE4,
    "gudangId"
  );

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );
  const produsen = useSelectOption(false, urlGetProdusen, TYPE_INSTANCE4);
  const supplier = useSelectOption(false, urlGetSupplier, TYPE_INSTANCE4);
  const tipe = useSelectOption(false, urlGetTipe, TYPE_INSTANCE4);

  const multipleSelectData = useMultipleSelect([
    {
      url: urlGetFiscal,
      search: true,
      type_instance: TYPE_INSTANCE4,
      value: "id",
      label: ["name"],
      type_response: "body",
      key: "fiscal",
      attr_addition: ["masa", "tarif"],
      attr_addition_value: ["masa_manfaat", "tarif_penyusutan"],
    },
  ]);

  const { disabledInput, setDisabledInput } = useContext(FormContext);
  // const tingkatAsset = useSelectOption(
  //   false,
  //   urlGetTingkatAsset,
  //   TYPE_INSTANCE4
  // );

  const metodePenyusutan = useSelectOption(
    false,
    urlGetMetodePenyusutan,
    TYPE_INSTANCE4
  );

  const getSetTypeAsset = async (id, nama) => {
    try {
      const api = await instance4.get(`${urlSetType}/${id}`);
      const res = api.data;
      const data = res.body[0];
      if (res.status === 200) {
        setFormData({
          ...formData,
          type_assets_id: id,
          nama_typeasset: nama,

          metode_penyusutan_id: data.metode_penyusutan_id,

          coa_fixassets_id: data.coa_fixassets_id,
          coa_fixassets: data.coa_fixassets_name,
          coa_fixassets_code: data.coa_fixassets_code,

          coa_akumulasi_id: data.coa_akumulasi_id,
          coa_akumulasi: data.coa_akumulasi_name,
          coa_akumulasi_code: data.coa_akumulasi_code,

          coa_bebanpenyusutan_id: data.coa_bebanpenyusutan_id,
          coa_bebanpenyusutan: data.coa_bebanpenyusutan_name,
          coa_bebanpenyusutan_code: data.coa_bebanpenyusutan_code,

          id_fiscal: data.type_fiscal_id,
          nama_fiscal: data.fiscal,

          masa_manfaat: data.masa_manfaat,
          tarif_penyusutan: data.tarif_penyusutan,
        });
        setDisabledInput(true);
      } else {
        defaultToastError();
      }
    } catch (error) {
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
          }}
        >
          <div
            style={{
              marginTop: "1.3rem",
              marginBottom: "0.5rem",
            }}
          >
            <InputCheckboxMaster
              checked={formData.status}
              name="status"
              id="status"
              label="AKTIF"
              className="pt-1"
              onChange={() => {
                setFormData({
                  ...formData,
                  status: !formData.status,
                });
                localStorage.setItem(
                  WMS_FA_INPUT,
                  JSON.stringify({
                    ...formData,
                    status: !formData.status,
                  })
                );
              }}
            />
          </div>

          <div
            style={{
              marginTop: "1.3rem",
              marginBottom: "0.5rem",
            }}
          >
            <InputCheckboxMaster
              checked={formData.is_asetberwujud}
              name="is_asetberwujud"
              id="is_asetberwujud"
              label="ASSET BERWUJUD"
              className="pt-1"
              onChange={() => {
                setFormData({
                  ...formData,
                  is_asetberwujud: !formData.is_asetberwujud,
                });
                localStorage.setItem(
                  WMS_FA_INPUT,
                  JSON.stringify({
                    ...formData,
                    is_asetberwujud: !formData.is_asetberwujud,
                  })
                );
              }}
            />
          </div>

          <div
            style={{
              marginTop: "1.3rem",
              marginBottom: "0.5rem",
            }}
          >
            <InputCheckboxMaster
              checked={formData.is_perhitungansusut}
              name="is_perhitungansusut"
              id="is_perhitungansusut"
              label="PERHITUNGAN SUSUT"
              className="pt-1"
              onChange={() => {
                setFormData({
                  ...formData,
                  is_perhitungansusut: !formData.is_perhitungansusut,
                });
                localStorage.setItem(
                  WMS_FA_INPUT,
                  JSON.stringify({
                    ...formData,
                    is_perhitungansusut: !formData.is_perhitungansusut,
                  })
                );
              }}
            />
          </div>

          <div
            style={{
              marginTop: "1.3rem",
              marginBottom: "0.5rem",
            }}
          >
            <InputCheckboxMaster
              checked={formData.is_tahun}
              name="is_tahun"
              id="is_tahun"
              label="PERHITUNGAN TAHUNAN"
              className="pt-1"
              onChange={() => {
                setFormData({
                  ...formData,
                  is_tahun: !formData.is_tahun,
                });
                localStorage.setItem(
                  WMS_FA_INPUT,
                  JSON.stringify({
                    ...formData,
                    is_tahun: !formData.is_tahun,
                  })
                );
              }}
            />
          </div>
        </div>
      </Grid>

      {isNull(headData.id) ? (
        <Grid item sm={12}>
          <InputOptionMaster
            name="id_unit"
            label="UNIT"
            id="id_unit"
            value={formData.unit_id}
            withSearch={true}
            data={unit}
            placeholder="Unit"
            labelValue={formData.nama_unit}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  unit_id: null,
                  nama_unit: "Pilih Unit",
                });
              } else {
                setFormData({
                  ...formData,
                  unit_id: e.value,
                  nama_unit: e.label,
                });
              }
            }}
          />
        </Grid>
      ) : (
        <></>
      )}

      <Grid item sm={12}>
        <InputOptionMaster
          name="gudang_id"
          label="GUDANG ASSET"
          id="gudang_id"
          value={formData.gudang_id}
          withSearch={true}
          data={gudangUtama}
          placeholder="Gudang Asset"
          labelValue={formData.gudang}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                gudang_id: null,
                gudang: "Pilih Gudang",
              });
            } else {
              setFormData({
                ...formData,
                gudang_id: e.value,
                gudang: e.label,
              });
            }
          }}
        />
      </Grid>
      <Grid item sm={12}>
        <InputOptionMaster
          name="produsen_id"
          label="PRODUSEN ASSET"
          id="produsen_id"
          value={formData.produsen_id}
          placeholder="Produsen Asset"
          withSearch={true}
          data={produsen}
          labelValue={formData.produsen}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                produsen_id: null,
                produsen: "Pilih Produsen",
              });
            } else {
              setFormData({
                ...formData,
                produsen_id: e.value,
                produsen: e.label,
              });
            }
          }}
        />
      </Grid>
      <Grid item sm={12}>
        <InputOptionMaster
          name="supplier_id"
          label="SUPPLIER ASSET"
          id="supplier_id"
          value={formData.supplier_id}
          placeholder="Supplier Asset"
          withSearch={true}
          data={supplier}
          labelValue={formData.supplier}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                supplier_id: null,
                supplier: "Pilih Supplier",
              });
            } else {
              setFormData({
                ...formData,
                supplier_id: e.value,
                supplier: e.label,
              });
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="type_asset"
          label="TIPE ASSET"
          id="type_asset"
          withSearch={true}
          data={tipe}
          value={formData.type_assets_id}
          labelValue={formData.nama_typeasset}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,

                type_assets_id: "",
                nama_typeasset: "Pilih Tipe Fixed Asset",

                metode_penyusutan_id: "",
                masa_manfaat: 0,
                tarif_penyusutan: 0,

                coa_fixassets_id: null,
                coa_fixassets: "Pilih COA",
                coa_fixassets_code: null,

                coa_akumulasi_id: null,
                coa_akumulasi: "Pilih COA",
                coa_akumulasi_code: null,

                coa_bebanpenyusutan_id: null,
                coa_bebanpenyusutan: "Pilih COA",
                coa_bebanpenyusutan_code: null,

                id_fiscal: "",
                nama_fiscal: "Pilih Fiscal",
              });
              setDisabledInput(false);
            } else {
              getSetTypeAsset(e.value, e.label);
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="type_fiscal"
          label="TIPE FISCAL"
          id="type_fiscal"
          withSearch={true}
          data={validasiMultipleSelect(multipleSelectData, 0)}
          // disabled={disabledInput}
          value={formData.id_fiscal}
          labelValue={formData.nama_fiscal}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                id_fiscal: null,
                nama_fiscal: "Pilih Fiscal",
                masa_manfaat: 0,
                tarif_penyusutan: 0,
              });
            } else {
              setFormData({
                ...formData,
                id_fiscal: e.value,
                nama_fiscal: e.label,
                masa_manfaat: e.masa,
                tarif_penyusutan: e.tarif,
              });
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="masa_manfaat"
          label="MASA MANFAAT (Bulan)"
          id="masa_manfaat"
          value={isNull(formData.masa_manfaat) ? "" : formData.masa_manfaat}
          onChange={handleChange("masa_manfaat")}
          placeholder="Masa Manfaat dalam Bulan"
          disabled={disabledInput}
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="tarif_penyusutan"
          label="TARIF PENYUSUTAN (%)"
          id="tarif_penyusutan"
          value={isNull(formData.tarif_penyusutan) ? "" : formData.tarif_penyusutan}
          onChange={handleChange("tarif_penyusutan")}
          placeholder="Tarif Penyusutan dalam %"
          max="100"
          disabled={disabledInput}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="metode_penyusutan_id"
          label="METODE PENYUSUTAN"
          id="metode_penyusutan_id"
          disabled={disabledInput}
          value={formData.metode_penyusutan_id}
          onChange={handleChange("metode_penyusutan_id")}
          placeholder="Metode Penyusutan"
          withSearch={false}
          data={metodePenyusutan}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="coa_fixassets_id"
          label="COA FIXED ASSET"
          id="coa_fixassets"
          withSearch={true}
          disabled={disabledInput}
          data={validasiMultipleSelect(coa, 0)}
          value={formData.coa_fixassets_id}
          labelValue={formData.coa_fixassets}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                coa_fixassets_id: null,
                coa_fixassets: "Pilih COA",
                coa_fixassets_code: null,
              });
            } else {
              setFormData({
                ...formData,
                coa_fixassets_id: e.value,
                coa_fixassets: e.label,
                coa_fixassets_code: e.code,
              });
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="coa_akumulasi"
          label="COA AKUMULASI"
          id="coa_akumulasi_id"
          withSearch={true}
          data={validasiMultipleSelect(coa, 0)}
          disabled={disabledInput}
          value={formData.coa_akumulasi_id}
          labelValue={formData.coa_akumulasi}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                coa_akumulasi_id: null,
                coa_akumulasi: "Pilih COA",
                coa_akumulasi_code: null,
              });
            } else {
              setFormData({
                ...formData,
                coa_akumulasi_id: e.value,
                coa_akumulasi: e.label,
                coa_akumulasi_code: e.code,
              });
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="coa_bebanpenyusutan_id"
          label="COA BEBAN PENYUSUTAN"
          id="coa_bebanpenyusutan_id"
          withSearch={true}
          data={validasiMultipleSelect(coa, 0)}
          disabled={disabledInput}
          value={formData.coa_bebanpenyusutan_id}
          labelValue={formData.coa_bebanpenyusutan}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                coa_bebanpenyusutan_id: null,
                coa_bebanpenyusutan: "Pilih COA",
                coa_bebanpenyusutan_code: null,
              });
            } else {
              setFormData({
                ...formData,
                coa_bebanpenyusutan_id: e.value,
                coa_bebanpenyusutan: e.label,
                coa_bebanpenyusutan_code: e.code,
              });
            }
          }}
        />
      </Grid>

      {/* <Grid item sm={12}>
        <InputOptionMaster
          name="tingkatasset_id"
          label="TINGKAT ASSET"
          id="tingkatasset_id"
          value={formData.tingkatasset_id}
          onChange={handleChange("tingkatasset_id")}
          placeholder="Tingkat Asset"
          withSearch={false}
          data={tingkatAsset}
        />
      </Grid> */}
      <Grid item sm={12}>
        <InputReactDatepicker
          selected={formData.tgl_mulai_kalibarasi}
          label=""
          dateFormat="dd/MM/yyyy"
          handleChangeToday={(e) =>
            setFormData({
              ...formData,
              tgl_mulai_kalibarasi: e,
            })
          }
          onChange={(e) =>
            setFormData({
              ...formData,
              tgl_mulai_kalibarasi: e,
            })
          }
          disabled={formData.is_kalibrasi ? false : true}
        />
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            marginTop: "-3.7rem",
          }}
        >
          <InputCheckboxMaster
            checked={formData.is_kalibrasi}
            name="is_kalibrasi"
            id="is_kalibrasi"
            label="KALIBRASI"
            onChange={() =>
              setFormData({
                ...formData,
                is_kalibrasi: !formData.is_kalibrasi,
              })
            }
          />
        </div>
      </Grid>
      <Grid item sm={12}>
        <InputReactDatepicker
          selected={formData.tanggal_maintenance}
          label=""
          dateFormat="dd/MM/yyyy"
          handleChangeToday={(e) =>
            setFormData({
              ...formData,
              tanggal_maintenance: e,
            })
          }
          onChange={(e) =>
            setFormData({
              ...formData,
              tanggal_maintenance: e,
            })
          }
          disabled={formData.is_maintenance ? false : true}
        />
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            marginTop: "-3.7rem",
          }}
        >
          <InputCheckboxMaster
            checked={formData.is_maintenance}
            name="is_maintenance"
            id="is_maintenance"
            label="Maintenance"
            onChange={() =>
              setFormData({
                ...formData,
                is_maintenance: !formData.is_maintenance,
              })
            }
          />
        </div>
      </Grid>
      <Grid item sm={12}>
        <InputTextArea
          label={"KETERANGAN"}
          placeholder={"Keterangan"}
          name="remark"
          value={isNull(formData.remark) ? "" : formData.remark}
          onChange={handleChange("remark")}
          id="remark"
          rows={"7"}
        />
      </Grid>
    </Grid>
  );
};
